enum TripLegEventType {
  DraftTripLegUpdated = 'DraftTripLegUpdated',
  OpenTripLegUpdated = 'OpenTripLegUpdated',
  OfferedTripLegUpdated = 'OfferedTripLegUpdated',
  AcceptedTripLegUpdated = 'AcceptedTripLegUpdated',
  OnHoldTripLegUpdated = 'OnHoldTripLegUpdated',
  TripLegAbandoned = 'TripLegAbandoned',
  TripLegAccepted = 'TripLegAccepted',
  TripLegArrived = 'TripLegArrived',
  TripLegBoarded = 'TripLegBoarded',
  TripLegCanceled = 'TripLegCanceled',
  TripLegCanceledLate = 'TripLegCanceledLate',
  TripLegCompleted = 'TripLegCompleted',
  TripLegConfirmed = 'TripLegConfirmed',
  TripLegDenied = 'TripLegDenied',
  TripLegDrafted = 'TripLegDrafted',
  TripLegDriverAssigned = 'TripLegDriverAssigned',
  TripLegDriverInTransit = 'TripLegDriverInTransit',
  TripLegHeld = 'TripLegHeld',
  TripLegInventoried = 'TripLegInventoried',
  TripLegManuallyAllocated = 'TripLegManuallyAllocated',
  TripLegNotLoaded = 'TripLegNotLoaded',
  TripLegOffered = 'TripLegOffered',
  TripLegOpened = 'TripLegOpened',
  TripLegRejected = 'TripLegRejected',
  TripLegEscalated = 'TripLegEscalated',
  TripLegEscalationCleared = 'TripLegEscalationCleared',
  TripLegUnderDiscussion = 'TripLegUnderDiscussion',
  TripLegUnderDiscussionCleared = 'TripLegUnderDiscussionCleared',
  TripLegCountsUpdated = 'TripLegCountsUpdated',
  TripLegException = 'TripLegException',
  TripLegExceptionAssigned = 'TripLegExceptionAssigned',
  TripLegExceptionCleared = 'TripLegExceptionCleared',
  TripLegVehicleAssigned = 'TripLegVehicleAssigned',
  WillCallTripLegActivated = 'WillCallTripLegActivated',
}

export { TripLegEventType };
